/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssureHeaderDto
 */
export interface AssureHeaderDto {
    /**
     * 
     * @type {string}
     * @memberof AssureHeaderDto
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof AssureHeaderDto
     */
    personType: string;
    /**
     * 
     * @type {Date}
     * @memberof AssureHeaderDto
     */
    customerSince?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssureHeaderDto
     */
    nextTermDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof AssureHeaderDto
     */
    contractsCount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssureHeaderDto
     */
    products: Array<string>;
}

/**
 * Check if a given object implements the AssureHeaderDto interface.
 */
export function instanceOfAssureHeaderDto(value: object): value is AssureHeaderDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('personType' in value) || value['personType'] === undefined) return false;
    if (!('contractsCount' in value) || value['contractsCount'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function AssureHeaderDtoFromJSON(json: any): AssureHeaderDto {
    return AssureHeaderDtoFromJSONTyped(json, false);
}

export function AssureHeaderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssureHeaderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'personType': json['personType'],
        'customerSince': json['customerSince'] == null ? undefined : (new Date(json['customerSince'])),
        'nextTermDate': json['nextTermDate'] == null ? undefined : (new Date(json['nextTermDate'])),
        'contractsCount': json['contractsCount'],
        'products': json['products'],
    };
}

export function AssureHeaderDtoToJSON(json: any): AssureHeaderDto {
    return AssureHeaderDtoToJSONTyped(json, false);
}

export function AssureHeaderDtoToJSONTyped(value?: AssureHeaderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'personType': value['personType'],
        'customerSince': value['customerSince'] == null ? undefined : ((value['customerSince'] as any).toISOString()),
        'nextTermDate': value['nextTermDate'] == null ? undefined : ((value['nextTermDate'] as any).toISOString()),
        'contractsCount': value['contractsCount'],
        'products': value['products'],
    };
}

